import { observable, action, computed } from "mobx";
import {post} from "../services/ajax.service";

class BudgetPlanningStore {
    @observable current_month_plan_pay = 0;
    @observable current_month = null;
    @observable current_year = null;
    @observable previous_year = null;
    @observable previous_month = null;
    @observable high_cost_drugs_count = 0;
    @observable previous_month_plan_pay = 0;
  
    @observable additional_drugs_cost = 0;
    @observable additional_individual_drugs =[];
    @observable url ="/api/v1/insightactions/budgetplanning";

    

    @computed get planPayPlusDrugsCost() {
        return (
          (parseFloat(this.previous_month_plan_pay)  + 
          parseInt(this.additional_drugs_cost))
        );
      }
    @action getPreviousMonthPlanPay = async (data) => {
        try {
            let response = await post(
              `${this.url}/getPreviousMonthPlanPay`,
              data
            );
      
            this.previous_month_plan_pay = response.data[0]?.PREV_COST;
            this.current_month_plan_pay = response.data[0]?.COST;
            this.current_month = response.data[0].MAX_MONTH;
            this.previous_month = response.data[0].PREVIOUS_MONTH;
            this.current_year = response.data[0].MAX_YEAR;
            this.previous_year = response.data[0].PREVIOUS_YEAR;

          } catch (err) {
            console.log(err);
          }

    }
    
    @action getHighDrugCostCount = async (data) => {
      this.high_cost_drugs_count = 0
      try {
          let response = await post(
            `${this.url}/getHighDrugCostCount`,
            data
          );
    
          this.high_cost_drugs_count =  response.data[0].drug_count;
        } catch (err) {
          console.log(err);
        }

  }
    @action getAdditionalDrugCosts = async (data) => {
        try {
            let response = await post(
              `${this.url}/getAdditionalDrugCosts`,
              data
            );
      
            this.additional_drugs_cost = response.data[0].drug_cost;
          } catch (err) {
            console.log(err);
          }

    }
    
    @action getAdditionalIndividualDrugs = async (data) => {
        try {
            let response = await post(
              `${this.url}/getAdditionalIndividualDrugs`,
              data
            );
      
            this.additional_individual_drugs = response.data;
          } catch (err) {
            console.log(err);
          }

    }
  
}

export default BudgetPlanningStore;
